export default ["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  // Now set up the states
  $stateProvider
    .state('eMails', {
    parent: "app",
    url: "/administration/eMails?createdAtFrom&createdAtUntil&sentAtFrom&sentAtUntil&to&template&subject",
    feature: "", //"menu.administration.eMails",
    views: {
      "main": {
        template: require("./eaEMailsPage/eaEMailsPageModule.html"),
        controller: "EMailsPageModuleController as $ctrl"
      }
    },
    resolve: {
      ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
        return $q((resolve)=> {
          require.ensure([], ()=> {

            let module = require("./index.js");
            $ocLazyLoad.load({name: module.default});
            resolve();
          });
        });
      }]
    }
  });
}];



// WEBPACK FOOTER //
// ./src/ui/modules/eaAdministration/eaEMails/routes.js